import { useCountdown } from 'src/hooks/useCountdown';
import IconSvg from 'src/assets/icons/IconSvg';

interface Props {
  endDate: string;
  className?: string;
}

const RaffleCountdown = ({ endDate, className }: Props) => {
  const timeLeft = useCountdown(endDate);
  const isExpired = timeLeft === '00d 00h 00m 00s';

  if (isExpired) {
    return <span className={`text-system-error ${className ?? ''}`}>Raffle Ended</span>;
  }

  return (
    <div className={`flex gap-1 items-center text-system-success ${className ?? ''}`}>
      <IconSvg icon="liveS" />
      <span>{timeLeft}</span>
    </div>
  );
};

export default RaffleCountdown;
